import { ExpenseOutputByIdStatus } from './expense-output-by-id-status.model';


export class ExpenseSelectByIdOutput implements IExpenseSelectByIdOutput {
    status!: number;
    message!: string;
    data!: ExpenseOutputByIdStatus;

    constructor(data?: IExpenseSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? ExpenseOutputByIdStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpenseSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IExpenseSelectByIdOutput {
    status: number;
    message: string;
    data: ExpenseOutputByIdStatus;
}

